var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_9_",
    "data-name": "calendar (9)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.302,
    height: 28.302,
    viewBox: "0 0 28.302 28.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(20.824 10.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M23.88,2.211H22.443V1.106a1.106,1.106,0,0,0-2.211,0V2.211H15.2V1.106a1.106,1.106,0,1,0-2.211,0V2.211H8.015V1.106a1.106,1.106,0,0,0-2.211,0V2.211H4.422A4.427,4.427,0,0,0,0,6.633V23.88A4.427,4.427,0,0,0,4.422,28.3H12.88a1.106,1.106,0,0,0,0-2.211H4.422A2.214,2.214,0,0,1,2.211,23.88V6.633A2.214,2.214,0,0,1,4.422,4.422H5.8V5.528a1.106,1.106,0,0,0,2.211,0V4.422H12.99V5.528a1.106,1.106,0,1,0,2.211,0V4.422h5.03V5.528a1.106,1.106,0,0,0,2.211,0V4.422H23.88a2.214,2.214,0,0,1,2.211,2.211v6.3a1.106,1.106,0,1,0,2.211,0v-6.3A4.427,4.427,0,0,0,23.88,2.211Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M276.689,270a6.689,6.689,0,1,0,6.689,6.689A6.7,6.7,0,0,0,276.689,270Zm0,11.166a4.478,4.478,0,1,1,4.478-4.478A4.483,4.483,0,0,1,276.689,281.166Z",
    transform: "translate(-255.075 -255.075)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M373.709,332.266h-.5v-1.161a1.106,1.106,0,1,0-2.211,0v2.266a1.106,1.106,0,0,0,1.106,1.106h1.6a1.106,1.106,0,0,0,0-2.211Z",
    transform: "translate(-350.492 -311.758)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(15.824 10.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(10.824 15.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5.824 10.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5.824 15.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5.824 20.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(10.824 20.824)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(10.824 10.824)",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.35786c23.svg";
export { ForwardRef as ReactComponent };